import 'normalize.css/normalize.css'
import '@/global.sass'

import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'

import App from '@/App.vue'

Vue.config.productionTip = false

Vue.use(new VueSocketIO({
  connection: 'https://awscloudmigration.techorange.com',
}))

new Vue({
  render: h => h(App),
}).$mount('#app')
